import { createApp } from "@mzhub/plexus";
import Layout from "@/components/Layout";
import "@/styles.css";

createApp({ Layout });
